<template>
  <div class="login-wrapper">
    <v-snackbar v-model="showSnackBar" color="black" right :timeout="timeout" style="z-index: 10000;">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <div style="position:relative; width:100%; min-height:100vh; overflow:hidden; background:#16211f; font-family: 'IBM Plex Sans', system-ui, sans-serif;">
      <!-- Background elements -->
      <div style="position:absolute; z-index:0; top:0; bottom:0; left:34%; right:0; overflow:hidden">
        <div style="position:absolute; inset:0; background:radial-gradient(70% 60% at 78% 4%, #eef3f2 0%, #c3d3ce 26%, #7d968f 52%, #3f5551 76%, #1f2c2a 100%)"></div>
        <div style="position:absolute; inset:0; opacity:.5; background:repeating-linear-gradient(94deg, rgba(24,42,32,.55) 0 10px, rgba(24,42,32,0) 10px 46px), repeating-linear-gradient(86deg, rgba(24,42,32,.4) 0 6px, rgba(24,42,32,0) 6px 38px)"></div>
        <div class="backdrop-img"></div>
      </div>
      <div style="position:absolute; z-index:1; inset:0; pointer-events:none; background:linear-gradient(90deg, rgba(20,28,30,.8) 0%, rgba(24,34,36,.24) 44%, rgba(255,255,255,.1) 66%, rgba(246,249,250,.2) 100%)"></div>
      <div style="position:absolute; z-index:1; inset:0; pointer-events:none; animation:sunbeam 13s ease-in-out infinite; background:radial-gradient(62% 58% at 86% 6%, rgba(240,246,248,.42) 0%, rgba(240,246,248,0) 62%)"></div>

      <!-- Left Panel Graphics -->
      <div class="left-panel">
        <svg width="100%" height="100%" viewBox="0 0 600 1000" preserveAspectRatio="none" style="position:absolute; inset:0; display:block; filter:drop-shadow(34px 0 70px rgba(8,14,10,.45))">
          <defs>
            <linearGradient id="pmPanel" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#09261a"></stop><stop offset="0.5" stop-color="#0c2e1f"></stop><stop offset="1" stop-color="#061a11"></stop></linearGradient>
            <linearGradient id="pmEdge" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#9ec9a6" stop-opacity="0"></stop><stop offset="0.45" stop-color="#9ec9a6" stop-opacity="0.75"></stop><stop offset="1" stop-color="#9ec9a6" stop-opacity="0"></stop></linearGradient>
          </defs>
          <path d="M0,0 H452 C556,168 372,318 452,494 C532,668 366,812 470,1000 H0 Z" fill="url(#pmPanel)"></path>
          <path d="M452,0 C556,168 372,318 452,494 C532,668 366,812 470,1000" fill="none" stroke="url(#pmEdge)" stroke-width="2.5" vector-effect="non-scaling-stroke"></path>
          <path d="M486,0 C590,170 404,320 486,496 C566,670 400,814 504,1000" fill="none" stroke="rgba(158,201,166,.22)" stroke-width="1" vector-effect="non-scaling-stroke"></path>
        </svg>
        
        <div style="position:relative; pointer-events:auto; height:100%; box-sizing:border-box; padding:40px 22% 40px 12%; display:flex; flex-direction:column; justify-content:center; align-items:center; text-align:center; gap:36px; max-width:720px">
          <!-- Text and Features -->
          <div style="display:flex; flex-direction:column; align-items:center; gap:20px; text-align:center">
            <div style="font-family:'Sora',sans-serif; font-size:18px; font-weight:700; letter-spacing:.05em; color:#eef0ec; white-space:nowrap">KERALA FOREST DEPARTMENT</div>
            <div style="font-family:'Sora',sans-serif; font-size:23px; font-weight:700; line-height:1.3; color:#eef0ec; white-space:nowrap">PROPERTY MARK</div>
            <div style="font-size:13.5px; line-height:1.6; color:rgba(214,220,214,.68); max-width:440px; text-wrap:pretty">Digitizing and managing forest applications and approvals in Kerala through a secure, transparent and efficient digital workflow.</div>
          </div>

          <!-- Features list -->
          <div style="display:flex; flex-direction:column; gap:22px; align-items:center">
            <div style="display:flex; align-items:flex-start; gap:16px; text-align:left; width:260px">
              <div style="width:46px; height:46px; flex:none; border-radius:50%; display:flex; align-items:center; justify-content:center; background:rgba(158,201,166,.1); border:1px solid rgba(158,201,166,.3)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9ec9a6" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path><path d="M9 13h6"></path><path d="M9 17h4"></path></svg>
              </div>
              <div style="display:flex; flex-direction:column; gap:4px; padding-top:3px">
                <div style="font-family:'Sora',sans-serif; font-size:15.5px; font-weight:600; color:#edefeb">Apply Online</div>
                <div style="font-size:13px; color:rgba(214,220,214,.52)">Submit forest applications seamlessly</div>
              </div>
            </div>
            <div style="display:flex; align-items:flex-start; gap:16px; text-align:left; width:260px">
              <div style="width:46px; height:46px; flex:none; border-radius:50%; display:flex; align-items:center; justify-content:center; background:rgba(158,201,166,.1); border:1px solid rgba(158,201,166,.3)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9ec9a6" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="2" width="6" height="5" rx="1"></rect><rect x="2" y="17" width="6" height="5" rx="1"></rect><rect x="16" y="17" width="6" height="5" rx="1"></rect><path d="M12 7v5"></path><path d="M5 17v-3h14v3"></path></svg>
              </div>
              <div style="display:flex; flex-direction:column; gap:4px; padding-top:3px">
                <div style="font-family:'Sora',sans-serif; font-size:15.5px; font-weight:600; color:#edefeb">Hierarchical Approvals</div>
                <div style="font-size:13px; color:rgba(214,220,214,.52)">Secure multi-level review process</div>
              </div>
            </div>
            <div style="display:flex; align-items:flex-start; gap:16px; text-align:left; width:260px">
              <div style="width:46px; height:46px; flex:none; border-radius:50%; display:flex; align-items:center; justify-content:center; background:rgba(158,201,166,.1); border:1px solid rgba(158,201,166,.3)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9ec9a6" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="M9 12l2 2 4-4"></path></svg>
              </div>
              <div style="display:flex; flex-direction:column; gap:4px; padding-top:3px">
                <div style="font-family:'Sora',sans-serif; font-size:15.5px; font-weight:600; color:#edefeb">Track &amp; Monitor</div>
                <div style="font-size:13px; color:rgba(214,220,214,.52)">Real-time status and updates</div>
              </div>
            </div>
          </div>

          <div style="display:flex; align-items:center; gap:12px; padding:14px 20px; border-radius:14px; background:rgba(20,32,32,.5); border:1px solid rgba(184,206,200,.2)">
            <svg width="20" height="20" style="flex:none" viewBox="0 0 24 24" fill="none" stroke="#9ec9a6" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
            <div style="font-size:12.5px; line-height:1.5; color:rgba(214,220,214,.7); text-align:left">Secure. Transparent. Responsible.<br><span style="color:#9ec9a6">For a Greener Kerala.</span></div>
          </div>
        </div>
      </div>

      <!-- Right Panel / Login Card -->
      <div class="right-panel">
        <div style="position:relative; width:100%; min-width:380px; max-width:470px; border-radius:26px; overflow:hidden; background:rgba(252,253,253,.93); backdrop-filter:blur(18px) saturate(1.2); box-shadow:0 44px 100px rgba(4,20,12,.45), inset 0 1px 0 rgba(255,255,255,.9); border:1px solid rgba(255,255,255,.7)">
          <!-- Removed top border per request -->
          <div style="position:absolute; left:0; right:0; bottom:0; height:74px; pointer-events:none; opacity:.5; background:repeating-linear-gradient(-52deg, rgba(75,138,95,.1) 0 2px, rgba(0,0,0,0) 2px 15px), linear-gradient(180deg, rgba(255,255,255,0), rgba(240,246,239,.9))"></div>

          <div style="position:relative; padding:32px 36px 32px; display:flex; flex-direction:column">
            <!-- Badges and Icon -->
            <div style="display:flex; justify-content:center; margin-bottom:12px">
              <div style="display:inline-flex; align-items:center; gap:9px; padding:6px 14px; border-radius:999px; background:#f2f6f5; border:1px solid rgba(75,138,95,.18)">
                <div style="width:6px; height:6px; border-radius:50%; background:#69a87b; animation:pulse 2.6s ease-in-out infinite"></div>
                <div style="font-family:'IBM Plex Mono',monospace; font-size:10px; letter-spacing:.15em; text-transform:uppercase; color:#3c4a44">Secure Access</div>
              </div>
            </div>
            <div style="display:flex; align-items:center; justify-content:center; gap:14px; margin-bottom:16px">
              <div style="width:40px; height:1px; background:linear-gradient(90deg, rgba(75,138,95,0), rgba(75,138,95,.3))"></div>
              <div style="width:44px; height:44px; border-radius:50%; display:flex; align-items:center; justify-content:center; background:linear-gradient(150deg,#eef4f3,#ffffff); border:1px solid rgba(75,138,95,.2); box-shadow:0 8px 20px rgba(75,138,95,.1)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4b8a5f" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"></path><path d="M2 21c0-3 1.85-5.36 5.08-6"></path></svg>
              </div>
              <div style="width:40px; height:1px; background:linear-gradient(90deg, rgba(75,138,95,.3), rgba(75,138,95,0))"></div>
            </div>

            <!-- Welcome Text -->
            <div style="display:flex; flex-direction:column; align-items:center; gap:4px; margin-bottom:20px; text-align:center">
              <div style="font-family:'Sora',sans-serif; font-size:28px; font-weight:700; line-height:1.1; color:#1b241f">Welcome Back!</div>
              <div style="font-size:14px; color:#727a73">Sign in to continue to your account</div>
            </div>

            <form @submit.prevent="validateInput">
              <div style="display:flex; flex-direction:column; gap:14px">
                <!-- Username Input -->
                <div style="display:flex; flex-direction:column; gap:8px">
                  <div style="font-family:'IBM Plex Mono',monospace; font-size:10.5px; font-weight:500; letter-spacing:.16em; text-transform:uppercase; color:#6a736c">Email / Username</div>
                  <div class="custom-input-wrap">
                    <svg width="17" height="17" style="flex:none" viewBox="0 0 24 24" fill="none" stroke="#93a396" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"></rect><path d="m3 6 9 7 9-7"></path></svg>
                    <input v-model="emailId" type="text" placeholder="name@kerala.gov.in" />
                  </div>
                </div>

                <!-- Password Input -->
                <div style="display:flex; flex-direction:column; gap:8px">
                  <div style="font-family:'IBM Plex Mono',monospace; font-size:10.5px; font-weight:500; letter-spacing:.16em; text-transform:uppercase; color:#6a736c">Password</div>
                  <div class="custom-input-wrap">
                    <svg width="17" height="17" style="flex:none" viewBox="0 0 24 24" fill="none" stroke="#93a396" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg>
                    <input v-model="password" :type="show3 ? 'text' : 'password'" placeholder="••••••••" style="letter-spacing:.04em" />
                    <v-icon @click="show3 = !show3" class="pw-toggle" size="20">
                      {{ show3 ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
                    </v-icon>
                  </div>
                </div>

                <!-- Extras -->
                <div style="display:flex; align-items:center; justify-content:space-between; margin-top:2px">
                  <div @click="rememberMe = !rememberMe" style="display:flex; align-items:center; gap:10px; cursor:pointer">
                    <div :class="['custom-checkbox', rememberMe ? 'checked' : '']">
                      <div class="custom-checkbox-dot"></div>
                    </div>
                    <span style="font-size:13.5px; color:#4f574f">Remember me</span>
                  </div>
                  <a href="#" @click.prevent="$router.push('/forgotpassword')" style="font-size:13.5px; font-weight:600">Forgot Password?</a>
                </div>

                <!-- Submit Button -->
                <button type="submit" class="submit-btn" @click.prevent="validateInput">
                  <span style="font-family:'Sora',sans-serif; font-size:16px; font-weight:600; letter-spacing:.02em; color:#ffffff">Sign In</span>
                  <span style="font-size:17px; color:#ffffff">→</span>
                </button>



                <!-- Footer Links -->
                <div style="text-align:center; font-size:13.5px; color:#727a73; margin-top:4px">
                  New user? <a href="#" @click.prevent="$router.push('/register')" style="font-weight:600">Register here →</a>
                </div>

                <div style="margin-top:16px; padding-top:14px; border-top:1px solid rgba(75,138,95,.14); display:flex; flex-direction:column; align-items:center; gap:3px">
                  <div style="font-family:'IBM Plex Mono',monospace; font-size:9px; letter-spacing:.2em; text-transform:uppercase; color:#98a09a">Developed &amp; Managed By</div>
                  <div style="font-family:'Sora',sans-serif; font-size:11.5px; font-weight:600; letter-spacing:.13em; color:#41564a">LEOPARD TECH LABS PVT. LTD.</div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "./../../store";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      emailId: null,
      otp: null,
      phone: null,
      username: null,
      password: null,
      show1: false,
      show2: true,
      show3: false,
      show4: false,
      rememberMe: false,
    };
  },
  mounted() {
    this.phone = this.$route.query.phone;
  },
  methods: {
    validateInput() {
      if (!this.emailId) {
        this.msg = "Please Provide Email";
        this.showSnackBar = true;
        return;
      } else {
        this.login();
      }
    },
    login() {
      const encryptedEmail = CryptoJS.AES.encrypt(this.emailId, 'film#$%^(*&!#_:"<>shoot').toString();
      const encryptedPassword = CryptoJS.AES.encrypt(this.password, 'film#$%^(*&!#_:"<>shoot').toString();
      axios({
        method: "post",
        url: "/user/login",
        data: {
          emailId: encryptedEmail,
          password: encryptedPassword,
        },
      })
        .then((response) => {
          if (response.data.status) {
            store.commit("loginUser", response.data.token);
            var uType = response.data.data.uType;
            var path = response.data.data.path;
            localStorage.setItem("uType", uType);
            localStorage.setItem("path", path);
            this.$store.commit("email", response.data.data.emailId);

            if (uType === 772) {
              store.commit("loginUser", response.data.token);
              this.$router.push({ path: "/mybooking" });
            }
            else if (uType === 773) {
              store.commit("loginUser", response.data.token);
              this.$router.push({ path: "/rangebookings" });
            }
            else if (uType === 7741) {
              store.commit("loginUser", response.data.token);
              this.$router.push({ path: "/sectionhome" });
            }
            else if (uType === 7742) {
              store.commit("loginUser", response.data.token);
              this.$router.push({ path: "/superintedent" });
            }
            else {
              this.$router.push({ path: "/divisiondashboard" });
            }
            location.reload()
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800&family=IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');

/* Animations */
@keyframes slowzoom { 0%{transform:scale(1.04)} 50%{transform:scale(1.11)} 100%{transform:scale(1.04)} }
@keyframes sunbeam { 0%,100%{opacity:.4} 50%{opacity:.85} }
@keyframes bob { 0%{transform:translateY(0)} 50%{transform:translateY(-8px)} 100%{transform:translateY(0)} }
@keyframes pulse { 0%,100%{opacity:.5; transform:scale(1)} 50%{opacity:1; transform:scale(1.3)} }

.login-wrapper {
  margin: 0;
  min-height: 100vh;
  background: #16211f;
  font-family: "IBM Plex Sans", system-ui, sans-serif;
}
.login-wrapper a {
  color: #3f7a53;
  text-decoration: none;
  transition: color .2s ease;
}
.login-wrapper a:hover {
  color: #26402f;
}

.backdrop-img {
  position: absolute;
  inset: 0;
  background-image: url('https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1920&q=80');
  background-size: cover;
  background-position: center;
  mix-blend-mode: overlay;
  opacity: 0.7;
  z-index: 1;
}

.custom-input-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  height: 48px;
  border-radius: 12px;
  background: #f4f6f6;
  border: 1px solid #e3e8e7;
  transition: all .22s ease;
}
.custom-input-wrap:hover {
  border-color: #a9c4bd;
  background: #f6f9f8;
}
.custom-input-wrap:focus-within {
  border-color: #4b8a5f;
  background: #ffffff;
}
.custom-input-wrap input {
  flex: 1;
  background: transparent;
  border: none;
  font-size: 15.5px;
  color: #1b241f;
  outline: none;
}
.custom-input-wrap input::placeholder {
  color: #9aa89c;
}

.pw-toggle {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 10px;
  letter-spacing: .12em;
  text-transform: uppercase;
  color: #3f7a53;
  cursor: pointer;
  padding: 6px;
  transition: color .2s ease;
}
.pw-toggle:hover {
  color: #1b241f;
}

.custom-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 1px solid #c3d0c5;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .18s ease;
}
.custom-checkbox.checked {
  background: #4b8a5f;
  border-color: #4b8a5f;
}
.custom-checkbox-dot {
  width: 7px;
  height: 7px;
  border-radius: 2px;
  background: #ffffff;
  opacity: 0;
  transition: opacity .18s ease;
}
.custom-checkbox.checked .custom-checkbox-dot {
  opacity: 1;
}

.submit-btn {
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  margin-top: 6px;
  transition: all .25s ease;
  background: linear-gradient(100deg,#4b8a5f 0%,#69a87b 55%,#9ec9a6 100%);
  box-shadow: 0 14px 32px rgba(75,138,95,.28);
  border: none;
  width: 100%;
}
.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 36px rgba(75,138,95,.35);
}


.left-panel {
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  bottom: 0;
  width: 56%;
  pointer-events: none;
}

.right-panel {
  position: relative;
  z-index: 3;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px 6% 24px calc(47% + 56px);
  min-width: 0;
}

@media (max-width: 960px) {
  .left-panel {
    display: none;
  }
  .right-panel {
    justify-content: center;
    padding: 24px 20px;
  }
}
</style>
